import { JetpacB2BApi } from 'api'
import { AxiosPromise } from 'axios'
import { GetAllUserOrderStatus } from 'types/api/faber/userOrderStatus.type'

class UsaAPI {
  static getAllUserOrderStatus(body: {
    searchCriteria: string
    searchValue: string
    faberToken: string
  }): AxiosPromise<GetAllUserOrderStatus> {
    let searchField = ''
    switch (body.searchCriteria) {
      case 'Email':
        searchField = 'user_id'
        break
      case 'Order ID':
        searchField = 'order_id'
        break
    }

    return JetpacB2BApi.httpGet(
      `/usermanagement?${searchField}=${body.searchValue.toLowerCase()}`,
      {
        Authorization: `Bearer ${body.faberToken}`
      }
    )
  }

}
export default UsaAPI
